const BEACON_SCRIPT_ID = 'everageBeaconScript';
const evergageAsync = evergageUrl => {
  /* eslint-disable prefer-const, no-var, no-unused-vars */
  var _aaq = window._aaq || (window._aaq = []);
  (function() {
    let d = document;
    if (!d.getElementById(BEACON_SCRIPT_ID)) {
      var g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0];
      g.type = 'text/javascript';
      g.defer = true;
      g.async = true;
      g.src = evergageUrl;
      g.id = BEACON_SCRIPT_ID;
      s.parentNode.insertBefore(g, s);
    }
  })();
  /* eslint-enable prefer-const, no-var, no-unused-vars */
};

export default evergageAsync;
